// Lib
import { createSelector } from 'reselect';

// Selectors
import { getCurrentBoardVisibleDescendants } from '../../../client/element/selectors/currentBoardSelector';
import { boardMediaFilter } from '../../../common/boards/boardMediaFilter';

// Utils
import { getFileSize } from '../../../common/elements/utils/elementPropertyUtils';
import { isImage } from '../../../common/elements/utils/elementTypeUtils';
import { isMilanoteHostedImage } from '../../element/image/imageElementUtils';

export const getCurrentBoardFileSizeSelector = createSelector(getCurrentBoardVisibleDescendants, (visibleDescendants) =>
    visibleDescendants.filter(boardMediaFilter).reduce((acc, element) => acc + getFileSize(element), 0),
);

export const currentBoardHasMediaElements = createSelector(
    getCurrentBoardVisibleDescendants,
    (visibleDescendants) => visibleDescendants.filter(boardMediaFilter).size > 0,
);

export const getCurrentBoardHasThirdPartyImagesSelector = createSelector(
    getCurrentBoardVisibleDescendants,
    (visibleDescendants) => visibleDescendants.filter(isImage).some((element) => !isMilanoteHostedImage(element)),
);

export const isExportPopupVisibleSelector = (state) => state.getIn(['app', 'popup', 'exportPopup', 'show']);

export const getBoardExports = (state) => state.get('boardExport');
